import type { FaireProductEntity } from "../../entity_types/product";

export const atc_fs_4: FaireProductEntity = {
  token: "atc_fs_4",
  type: "product",
  name: "Churro Lip Scrub",
  brandName: "Sin-Min",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/b628d05200164eeb28c0b30d8ede8ef8392888c60d90979a5c76ade6071fe93e.webp",
  priceDollars: 12,
  msrpDollars: 24,
  description: "ATC migration seed product",
  tags: ["beauty", "atc"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
